import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { UploadFormService } from '@/services/uploadForm.service'

export const useFileSaveAndClose = () => {
	const navigate = useNavigate()
	const { id } = useParams()

	const handleSaveAndClose = useCallback(async () => {
		if (!id) return navigate('/home')

		try {
			const formData = await UploadFormService.getFormData(id)

			if (!formData || formData.is_completed === true) {
				navigate('/home')
				return
			}

			// is_completed === false
			sessionStorage.setItem('openFormModal', id)
			navigate('/home')
		} catch (error) {
			console.log(error)
			navigate('/home')
		}
	}, [id, navigate])

	const goHome = useCallback(() => {
		navigate('/home')
	}, [navigate])

	return {
		handleSaveAndClose,
		goHome
	}
}
